import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let RouterParamsOrderStatusMixin = class RouterParamsOrderStatusMixin extends Vue {
    get orderStatus() {
        const route = this.$route.params;
        return route.status || '';
    }
};
RouterParamsOrderStatusMixin = __decorate([
    Component
], RouterParamsOrderStatusMixin);
export default RouterParamsOrderStatusMixin;
